// Line OD to ID mapping for ACR copper tubing (ASTM B280), inches
const LINE_OD_TO_ID:Record<string, number> = {
    '3/8': 0.311,
    '1/2': 0.436,
    '5/8': 0.555,
    '3/4': 0.666,
    '7/8': 0.785,
    '1-1/8': 1.025,
    '1-3/8': 1.265,
    '1-5/8': 1.505,
}

export type LineOd =
    | '3/8'
    | '1/2'
    | '5/8'
    | '3/4'
    | '7/8'
    | '1-1/8'
    | '1-3/8'
    | '1-5/8'

export type SystemType =
    | 'residential-ac'
    | 'residential-heat-pump'
    | 'light-commercial-ac'
    | 'light-commercial-heat-pump'
    | 'mini-split'
    | 'commercial-refrigeration'
    | 'walk-in-cooler'
    | 'walk-in-freezer'
    | 'commercial-chiller'
    | 'other'

export interface ChargeSizeInput {
    liquidDensityLbGal:number;
    lineOd:LineOd;
    totalLineLengthFt:number;
    verticalRiseFt:number;
    factoryChargeLbs:number;
    includedLengthFt?:number;
}

export interface ChargeSizeResult {
    factoryChargeLbs:number;
    lineSetAdditionLbs:number;
    estimatedTotalChargeLbs:number;
    ouncesPerFoot:number;
    longRunFlag:boolean;
    verticalRiseFlag:boolean;
}

export function calcChargeSize (input:ChargeSizeInput):ChargeSizeResult {
    const {
        liquidDensityLbGal,
        lineOd,
        totalLineLengthFt,
        verticalRiseFt,
        factoryChargeLbs,
    } = input
    const includedLengthFt = input.includedLengthFt ?? 15

    const id = LINE_OD_TO_ID[lineOd]
    const radius = id / 2
    // volume per linear foot of line in cubic inches (1 ft = 12 in)
    const volumePerFootIn3 = Math.PI * radius * radius * 12
    // 1 gallon = 231 cubic inches
    const densityLbIn3 = liquidDensityLbGal / 231
    const ouncesPerFoot = volumePerFootIn3 * densityLbIn3 * 16

    const excessFt = Math.max(0, totalLineLengthFt - includedLengthFt)
    const lineSetAdditionLbs = (excessFt * ouncesPerFoot) / 16

    return {
        factoryChargeLbs,
        lineSetAdditionLbs,
        estimatedTotalChargeLbs: factoryChargeLbs + lineSetAdditionLbs,
        ouncesPerFoot,
        longRunFlag: totalLineLengthFt > 50,
        verticalRiseFlag: verticalRiseFt > 15,
    }
}
